export const POSITION = {
  LEFT: 0,
  RIGHT: 1
};

export const ACTIVE = {
  ACTIVE: 0,
  DISABLED: 1
};